import React from 'react'
import SEO from '../seo'
import PageTitle from '../page-title'
import SubTitle from '../sub-title'
import ProfileImage from '../images/profileImage'
import styles from './About.module.css'

const About = () => {
  return (
    <div className={styles.container}>
      <SEO title="About us" />

      <PageTitle>About us</PageTitle>
      <p>
        Founded in 2017 by Rupali Gaekwad, Mayurpankh Events aims to bring
        forward the deserving talents from various parts of India and present
        them in front of different audiences.
        <br />
        <em>Mayurpankh Events is always associated with social causes.</em>
      </p>

      <section className={styles.section}>
        <SubTitle>Founder</SubTitle>
        <div className={styles.profileImageContainer}>
          <ProfileImage alt="Rupali Gaekwad" className={styles.profileImg} />
        </div>

        <p>
          <em className={styles.founderName}>Rupali Gaekwad</em> is a former
          cabin crew of Air India and a respected trainer in the field of
          aviation and hospitality. Being married to an Air Force officer, she
          has constantly moved on posting within the country and abroad which
          gave her opportunities to experience diverse cultures.
        </p>
        <p>
          Over the years she realised her love for arts and passion for music,
          which brought her close to many artists and artisans. She launched
          Mayurpankh Events to create a platform for these artists and artisans.
        </p>

        <p>
          She is on the panel of <em>All India Radio as a Guest Speaker</em>{' '}
          where she delivers talks on current social and environmental issues.
          Recently, Prama Jyoti Foundation and Democracy News Live have
          nominated Rupali for <em>Chetna Hero</em> for her work in the field of
          arts.
        </p>
      </section>

      <section className={styles.section}>
        <SubTitle>Approach</SubTitle>
        <p>
          We use various social media platforms to promote artists and artisans.
        </p>
        <p>
          We make use of a strong network of patrons of art, artists and music
          worldwide to increase their visibility to masses.
        </p>
      </section>

      <section className={styles.section}>
        <SubTitle>Mission</SubTitle>

        <p>
          We organize cultural programs to preserve melodies of golden era of
          Hindi cinema, classical dance forms, etc. These programs are also a
          means to spread awareness on social issues.
        </p>
        <p>
          These quality programs are stress busters in todays’ stressful
          environment and the audience always looks forward to her programs.
        </p>
      </section>
    </div>
  )
}

export default About
